import React, { useRef, useLayoutEffect, useState } from "react";
// import Table from "antd/lib/table";

import "antd/lib/table/style/index.css";
import "antd/lib/pagination/style/index.css";
import styles from "./TableComponent.module.scss";

import { useModal } from "../stores/useModel";
import PlaceholderModal from "./model/PlaceholderModal";
import LoadingSpinner from "./LoadingSpinner";

const Table = React.lazy(() => import("antd/lib/table"));

type Props = {
  columns: any[];
  data: any[];
  showSelection?: boolean;
  rowHeight?: number;
};

function TableComponent({ columns, data, showSelection = true, rowHeight = 39 }: Props) {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const [paginationSize, setPaginationSize] = useState(0);
  const { setShowModal, setModalContent } = useModal(state => state);

  useLayoutEffect(() => {
    const rawAvailableSpace = tableContainerRef.current!.getBoundingClientRect().height;
    // 56 = table footer's height, 37  = table header's height
    const availableSpace = rawAvailableSpace - (56 + 36);

    setPaginationSize(Math.floor(availableSpace / rowHeight));
  }, []);

  return (
    <div className={styles.container} ref={tableContainerRef}>
      <React.Suspense
        fallback={
          <div className={styles.spinnerContainer}>
            <LoadingSpinner />
          </div>
        }
      >
        <Table
          dataSource={data}
          columns={columns}
          size="small"
          pagination={{
            position: ["bottomRight"],
            pageSize: paginationSize,
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {
                setShowModal(true);
                setModalContent(
                  <PlaceholderModal>Placeholder for TableRow</PlaceholderModal>
                );
              },
            };
          }}
          rowSelection={
            showSelection
              ? {
                  type: "checkbox",
                  onChange: (selectedRowKeys, selectedRows) => {
                    // console.log(
                    //   `selectedRowKeys: ${selectedRowKeys}`,
                    //   "selectedRows: ",
                    //   selectedRows
                    // );
                  },
                  getCheckboxProps: record => ({
                    // Column configuration not to be checked
                    // name: record.name,
                  }),
                }
              : undefined
          }
          loading={true}
          // bordered={true}
        />
      </React.Suspense>
    </div>
  );
}

export default React.memo(TableComponent);
